module.exports = __webpack_public_path__ + "static/media/setting.378df765.svg";